import { EventDay, formatStartDate, getPlacement } from '../../helpers'
import {
    StyledDayButton,
    StyledRowOfDaysContainer,
    StyledSwiper,
    StyledSwiperSlide,
} from './RowOfDays.styled'
import { isToday, parseISO } from 'date-fns'
import { useMemo, useState } from 'react'
import 'swiper/css'

const getCurrentDayFromListOfEventDays = (eventDays: EventDay[]) => {
    const today = eventDays.find((el) => {
        const dateFormatted = formatStartDate(el.dateValue)
        return isToday(parseISO(dateFormatted))
    })
    return today
}

const getIndexOfCurrentDate = (eventDays: EventDay[]) => {
    const currentDay = getCurrentDayFromListOfEventDays(eventDays)
    if (currentDay) {
        const currentDayIndex = eventDays.findIndex((el) => {
            return el.dateValue === currentDay.dateValue
        })
        return currentDayIndex
    }
}

type RowOfDaysProps = {
    selectedDate: string
    setSelectedDate: React.Dispatch<React.SetStateAction<string>>
    eventDays: EventDay[]
}

const RowOfDays = (props: RowOfDaysProps) => {
    const { selectedDate, setSelectedDate, eventDays } = props
    const [swiperRef, setSwiperRef] = useState<any>(null)

    const displayEventDays = useMemo(() => {
        const currentDay = getCurrentDayFromListOfEventDays(eventDays)
        return eventDays.map((eventDay) => {
            if (currentDay && currentDay.dateValue === eventDay.dateValue) {
                return {
                    ...eventDay,
                    dateLabel: `Today - ${eventDay.dateLabel}`,
                }
            }
            return eventDay
        })
    }, [eventDays])

    const handleButtonClick = (selectedDateValue: string, selectedIndex: number) => {
        setSelectedDate(selectedDateValue)

        if (!swiperRef) {
            return
        }

        // Keep a visible leading gutter by shifting selected item one slot from the edge when possible.
        const targetIndex = selectedIndex > 0 ? selectedIndex - 1 : 0
        swiperRef.slideTo(targetIndex)
    }

    return (
        <StyledRowOfDaysContainer>
            <StyledSwiper
                slidesPerView={'auto'}
                onSwiper={(swiper) => {
                    setSwiperRef(swiper)
                    const currentDateIndex = getIndexOfCurrentDate(displayEventDays)
                    if (currentDateIndex !== undefined) {
                        if (currentDateIndex > 0) {
                            swiper.slideTo(currentDateIndex - 1)
                        } else {
                            swiper.slideTo(0)
                        }
                    }
                }}
                slideToClickedSlide={false}
                // keep a stable left gutter while sliding through later dates
                slidesOffsetBefore={20}
                // fixes issue where unable to scroll to last slide
                slidesOffsetAfter={20}
            >
                {displayEventDays.map((el, index) => (
                    <StyledSwiperSlide
                        key={index}
                        style={{ backgroundColor: getPlacement() === '7plus' ? '#000000' : 'initial' }}
                    >
                        <StyledDayButton
                            onClick={() => handleButtonClick(el.dateValue, index)}
                            isSelected={selectedDate === el.dateValue}
                        >
                            {el.dateLabel}
                        </StyledDayButton>
                    </StyledSwiperSlide>
                ))}
            </StyledSwiper>
        </StyledRowOfDaysContainer>
    )
}

RowOfDays.displayName = 'RowOfDays'

export default RowOfDays
